<template>
  <div class="container">
    <div class="backgroundImage">
      <img src="../../../static/image/68wxLogo.png" class="68wxLogo" alt="">
    </div>
    <el-container class="bg">
      <!-- <div class="main-logo">
        <div>新网校题库代理后台</div>
      </div>-->
      <div class="log-row">
        <img src="../../../static/image/reactBack.png" class="reactBack" alt="">
        <div class="card-page">
          <!-- <div class="main-title">用户登录</div> -->
          <div class="main-title">登 录</div>
          <el-form :model="form" :rules="rules" status-icon ref="ruleForm" style="margin-top:20px" label-position="left" label-width="-10px">
            <!-- <p class="title">管理员登录</p> -->
            <el-form-item prop="account" class="card-item card-item-username">
              <el-input type="text" v-model="form.account" auto-complete="off" placeholder="用户名" @keyup.enter.native="login"></el-input>
            </el-form-item>
            <el-form-item prop="password" class="card-item">
              <el-input type="password" v-model="form.password" auto-complete="off" placeholder="密码" @keyup.enter.native="login"></el-input>
            </el-form-item>
            <!--<el-form-item prop="code" class="card-item">-->
            <!--<el-row>-->
            <!--<el-col :span="18">-->
            <!--<el-input-->
            <!--type="code"-->
            <!--v-model="form.code"-->
            <!--auto-complete="off"-->
            <!--placeholder="验证码"-->
            <!--@keyup.enter.native="handleSubmit"-->
            <!--&gt;</el-input>-->
            <!--</el-col>-->
            <!--<el-col :span="6">-->
            <!--<el-image class="codeImg" :src="validateCodePath" @click="changeCode"></el-image>-->
            <!--</el-col>-->
            <!--</el-row>-->
            <!--</el-form-item>-->
            <el-form-item class="card-item">
              <div class="loginBtn" @click="login">
                <span>登录</span>
              </div>
            </el-form-item>
            <el-form-item class="card-item card-item-findLink">
              <div class="jsb">
                <!-- <div class="findLink" @click="toRegister">去注册</div> -->
                <div class="findLink"></div>
                <div class="findLink" @click="findPassword">找回密码</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="footer-content">© {{format('yyyy',new Date(new Date()))}} - 弘智教育集团</div>
    </el-container>

    <el-dialog title="身份认证" :visible.sync="verifyVisible" width="490px" left>
      <Verify @success="verifySuccess" :type="verify.type" :mode="verify.mode" :vOffset="verify.vOffset" :vSpace="verify.vSpace" :explain="verify.explain" :imgUrl="verify.imgUrl" :imgName="verify.imgName" :imgSize="verify.imgSize" :blockSize="verify.blockSize" :barSize="verify.barSize" :showButton="verify.showButton"></Verify>
    </el-dialog>

    <el-dialog title="找回密码" :visible.sync="findPasswordVisible" :close-on-click-modal="false" width="440px">
      <el-form :model="findPasswordForm" :rules="findPasswordRules" status-icon ref="findPasswordForm" label-position="left" label-width="0px">
        <el-form-item prop="mobile" class="findPassword-item">
          <el-input type="text" v-model="findPasswordForm.mobile" auto-complete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="code" class="findPassword-item">
          <el-input type="text" v-model="findPasswordForm.code" auto-complete="off" placeholder="验证码" style="width:200px;"></el-input>
          <el-button v-if="codeBtnShow" type="primary" class="sendCodeBtn" style="width:116px;" @click="getCode">
            <!-- <span>发送验证码</span> -->
            <span>获取验证码</span>
          </el-button>
          <el-button v-if="!codeBtnShow" type="primary" class="sendCodeBtn" style="width:116px;">
            <span>{{count}} s</span>
          </el-button>
        </el-form-item>
        <el-form-item prop="password" class="findPassword-item">
          <el-input type="password" v-model="findPasswordForm.password" auto-complete="off" placeholder="新密码" @keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-form-item class="findPassword-item">
          <el-button type="primary" class="confirmPasswordBtn" @click="confirmPassword">
            <span>确认</span>
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="设备授权" :visible.sync="deviceAuthorizeVisible" :close-on-click-modal="false" width="440px">
      <el-form :model="deviceAuthorizeForm" :rules="findPasswordRules" status-icon ref="deviceAuthorizeForm" label-position="left" label-width="0px">
        <el-form-item prop="mobile" class="findPassword-item">
          <el-input type="text" v-model="deviceAuthorizeForm.mobile" disabled auto-complete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="code" class="findPassword-item">
          <el-input type="text" v-model="deviceAuthorizeForm.code" auto-complete="off" placeholder="验证码" style="width:200px;"></el-input>
          <el-button v-if="codeBtnShow" type="primary" class="sendCodeBtn" style="width:116px;" @click="getAdminCode">
            <span>获取验证码</span>
          </el-button>
          <el-button v-if="!codeBtnShow" type="primary" class="sendCodeBtn" style="width:116px;">
            <span>{{count}} s</span>
          </el-button>
        </el-form-item>
        <el-form-item class="findPassword-item">
          <el-button type="primary" class="confirmPasswordBtn" @click="confirmLoginByCode">
            <span>授权当前设备登录</span>
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="选择账号" :visible.sync="selectDataVisible" :close-on-click-modal="false" width="900px">
      <el-row :gutter="20">
        <el-col :span="8" v-for="(item,index) in AgentInfoList" :key="index">
          <div class="selectLogin" @click="loginIn(item.id)">{{item.name}}</div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import Verify from "vue2-verify";
import md5 from "md5";
export default {
  components: {
    Verify,
  },
  data () {
    var validateMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        if (value !== "") {
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(value)) {
            callback(new Error("请输入正确的手机号码"));
          }
        }
        callback();
      }
    };
    return {
      verify: {
        type: 4,
        mode: "fixed",
        vOffset: 3,
        vSpace: 5,
        explain: "向右滑动完成验证",
        imgUrl: "static/image/",
        imgName: [
          "1.png",
          "2.png",
          "3.png",
          "4.png",
          "5.png",
          "6.png",
          "7.png",
          "8.png",
          "9.png",
          "10.png",
        ],
        imgSize: { width: "450px", height: "260px" },
        blockSize: { width: "40px", height: "40px" },
        barSize: { width: "450px", height: "40px" },
        showButton: false,
      },
      AgentInfoList: [],
      selectDataVisible: false,
      verifyVisible: false,
      validateCodePath: "",
      rules: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      form: {
        account: "",
        code: "",
        password: "",
      },
      logData: {},
      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
      findPasswordVisible: false,
        deviceAuthorizeVisible: false,
      findPasswordForm: {
        mobile: "",
        code: "",
        password: "",
      },
        deviceAuthorizeForm: {
            mobile: "",
            code: "",
        },
      findPasswordRules: {
        mobile: [{ validator: validateMobile, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
      },
      codeBtnShow: true,
      count: "",
      timer: null,
    };
  },
  methods: {
    getGuid () {
      function S4 () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }

      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    changeCode () {
      this.rnd = this.getGuid();
      // this.validateCodePath =
      //   this.crmBaseUrl + "/system/validatecode/get?rnd=" + this.rnd;
    },
    //  登录功能
    login () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
            this.agentValidate();
        } else {
          return false;
        }
      });
    },

    agentValidate(){
        //  机构问题
        this.AgentInfoList = [];
        this.api.agentUserInfo
          .getAgentInfoListByAccount({ account: this.form.account })
          .then((result) => {
            if (result.success) {
              this.AgentInfoList = result.data;
                if (this.AgentInfoList.length <= 1) {
                this.loginIn();
              } else {
                this.selectDataVisible = true;
              }
            } else {
              this.$message.error(result.message);
            }
          });
    },

    loginIn (id) {
      const loading = this.$loading.service({
        lock: true,
        text: "验证登录信息",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.api.system
        .login({
          account: this.form.account,
          password: this.form.password,
          agentId: id
        })
        .then((result) => {
          if (result.success) {
            this.logData = result.data;
            this.selectDataVisible = false;
            loading.close();
            if (result.data.flag==1) {
              this.$alert('为保证系统安全性，需进行登录设备授权,点击确定进入授权（默认60天）操作！', '信息', {
                  confirmButtonText: '确定',
                  showClose:false,
                  callback: action => {
                      this.deviceAuthorizeVisible=true;
                      this.deviceAuthorizeForm.mobile = this.form.account;
                  }
              });
            } else {
              this.verifyVisible = true;
            }
          } else {
            this.selectDataVisible = false;
            loading.close();
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          loading.close();
          console.log(error);
        });
    },
    verifySuccess () {
      // this.$router.push({ name: "main" });
      this.$router.push(this.$route.query.redirect || "/main");
      this.$notify({
        title: "消息",
        message: "登录成功!",
        type: "success",
        duration: 1500,
      });
      this.$store.commit("signIn", this.logData);
       this.$store.dispatch("getAuthList");
    },
    findPassword () {
      this.findPasswordForm = {
        mobile: this.form.account,
        code: "",
        password: "",
      };
      this.findPasswordVisible = true;
    },
      getAdminCode () {
          this.$refs.deviceAuthorizeForm.validateField("mobile", (errMsg) => {
              if (!errMsg) {
                  this.api.system
                          .getAdminSMSCode({
                              mobile: this.deviceAuthorizeForm.mobile,
                          })
                          .then((result) => {
                              if (result.success) {
                                  this.$message({
                                      message: "短信已发送",
                                      type: "success",
                                  });
                                  this.timeInterval();
                              }
                          })
                          .catch((error) => {
                              console.log(error);
                          });
              }
          });
      },

      getCode () {
        this.$refs.findPasswordForm.validateField("mobile", (errMsg) => {
          if (!errMsg) {
            this.api.system
              .getSMSCode({
                account: this.findPasswordForm.mobile,
              })
              .then((result) => {
                if (result.success) {
                  this.$message({
                    message: "短信已发送",
                    type: "success",
                  });
                  this.timeInterval();
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
    },


    //倒计时
    timeInterval () {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeBtnShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeBtnShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    toRegister () {
      this.$router.push("register")
    },

    confirmLoginByCode () {
        this.$refs.deviceAuthorizeForm.validate((valid) => {
            if (valid) {
                this.api.system
                        .loginByCode({
                            mobile: this.deviceAuthorizeForm.mobile,
                            code: this.deviceAuthorizeForm.code
                        })
                        .then((result) => {
                            if (result.success) {
                                this.$message({
                                    message: result.message,
                                    type: "success",
                                });
                                this.deviceAuthorizeVisible = false;
                                this.verifySuccess();
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
            } else {
                return false;
            }
        });
    },
    confirmPassword () {
      this.$refs.findPasswordForm.validate((valid) => {
        if (valid) {
          this.api.system
            .resetPassword({
              mobile: this.findPasswordForm.mobile,
              smsCode: this.findPasswordForm.code,
              password: md5(this.findPasswordForm.password),
            })
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: result.message,
                  type: "success",
                });
                this.findPasswordVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
  },
  mounted () {
    this.changeCode();
    if (this.$store.state.isLogin) {
      this.$router.push(this.$route.query.redirect || "/main");
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.isLogin;
    },
  },
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 600px;
}

.reactBack {
  width: 480px;
}
.log-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 1000px;
  margin: 0 auto;
  align-items: center;
}
.card-page {
  width: 520px;
  height: 100%;
  padding: 40px 70px;
  /* padding: 30px 50px 40px 50px; */
  background: #fff;
  box-sizing: border-box;
  border: 1px solid #eaeaea;
}

.title {
  text-align: center;
  font-size: 20px;
}

.card-item {
  margin: 30px 0;
  width: 100%;
}

.card-item-password {
  margin-top: 90px;
}

.card-item-findLink {
  margin-top: -20px;
}

.loginBtn {
  width: 100%;
  color: #fff;
  border-radius: 56px;
  background-color: #136ffe;
  border: 0px;
  line-height: 56px;
  height: 56px;
  text-align: center;
  margin-top: 20px;
}
.loginBtn:hover {
  cursor: pointer;
  background-color: #136ffe;
}

.loginBtn span {
  font-size: 18px;
}

.codeImg {
  width: 80px;
  height: 40px;
  cursor: pointer;
}
/*
.main-title {
  background-color: #4d94ff;
  height: 60px;
  width: 240px;
  position: absolute;
  top: -30px;
  left: 100px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  -webkit-border-radius: 30px;
  border-radius: 30px;
  line-height: 60px;
} */

.main-title {
  color: #000;
  font-size: 20px;
  text-align: center;
  margin-top: 20px;
}
.findLink {
  color: #4d97ff;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}

.main-logo {
  display: flex;
  display: -webkit-flex;
  position: absolute;
  left: calc(50% - 150px);
  top: 10%;
  height: 40px;
  line-height: 40px;
  z-index: 1111;
}

.main-logo div {
  font-size: 30px;
  width: 300px;
  color: #fff;
  align-items: center;
}
.bg {
  position: relative;
  margin-top: 60px;
}
.footer-content {
  position: absolute;
  bottom: -30px;
  width: 100%;
  font-size: 12px;
  color: #000;
  text-align: center;
}

.findPassword-item {
  margin: 10px 40px;
  height: 48px;
  width: 320px;
}

.sendCodeBtn {
  color: #fff;
  border-radius: 2px;
  background-color: #4d97ff;
  height: 36px;
  line-height: 1px;
}

.sendCodeBtn span {
  font-size: 16px;
}

.confirmPasswordBtn {
  color: #fff;
  border-radius: 2px;
  background-color: #4d97ff;
  height: 36px;
  width: 320px;
  line-height: 12px;
}

.confirmPasswordBtn span {
  font-size: 18px;
}
.backgroundImage {
  display: flex;
  padding-top: 20px;
  padding-left: 60px;
}
.backgroundImage img {
  width: 100px;
}
.textStyle {
  display: inline-grid;
  margin-left: 20px;
}
.lineStyle {
  border-left: 1px solid #ccc;
  margin-left: 20px;
}
.selectLogin {
  margin-bottom: 20px;
  border: 1px solid #eee;
  border-radius: 50px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.selectLogin:hover {
  cursor: pointer;
  border: 1px solid #409eff;
}
.jsb {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
<style>
.card-item .el-input__inner {
  border-radius: 2px;
  height: 36px;
}



// WEBPACK FOOTER //
// src/components/login/index.vue